<template>
    <div>
        <div v-if="showcargando == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>

        <v-card flat class="text-xs-center">
            <v-card-title class="justify-center primary">
                <v-toolbar-title id="titulocard">Movimientos</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>

                <v-row v-if="this.mostrarAlert == true">


                    <v-alert dense border="left" type="warning"
                        style="align-self: center; margin: 15px; width: 100%; padding: 15px">
                        <strong>Reporte Archivado</strong>
                        <p>
                            No es posible visualizar la información,contacte a desarrollo.
                        </p>
                    </v-alert>

                </v-row>
                <v-row v-if="this.mostrarAlert == false">

                    <v-col cols="12" md="3" v-if="ci">
                        <v-switch v-model="switchci" label="Mostrar movimientos con CI" inset
                            @change="movimientossinCI()">
                        </v-switch>
                    </v-col>
                    <v-col cols="12" md="12" v-if="abrir">
                        <DataTable :url="urlListado" :columns="columns" :formatterActions="formatterActions"
                            :params="displayInputs" :order="[[0, 'desc']]" @apiDT="apiDT = $event" :movil="isMovil"
                            @Cancelar="CancelarShow"></DataTable>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

    </div>
</template>
<script>

import { mapActions, mapState } from 'vuex';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import movimiento from '@/services/Movimientos/Movimientos.service.js';
import DataTable from "@/components/pages/DataTableNet/DataTable";
import General from '@/services/ReporteGeneral/ReporteGeneral.service.js';
import Asistencia from '@/services/AsistenciaGeneral/AsistenciaGeneral.service.js';

export default {
    components: {
        DataTable
    },
    data: function () {
        return {
            apiDT: null,
            abrir: false,
            showcargando: true,
            listado: [],
            aiclave: '',
            veTabla: false,
            veEdita: false,
            veElimina: false,
            vivr: false,
            perfil: '',
            switchci: true,
            nrreporte: '',
            svindice: '',
            /////////////////////////////////////////////////////////////////////////
            urlListado: "Movimientos/ObtenerMovimientos",
            columns: [
                { name: 'Visto', data: 'Visto', title: "Visto", formatter: [this, "mvisto"], orderable: false },
                { name: 'Esid', data: 'Esid', title: "T.P.", formatter: [this, "tpreporte"], orderable: false },
                { name: 'Exfechas', data: 'Exfechas', title: "Fecha" },
                { name: 'Exfechaabo', data: 'Exfechaabo', title: "Fecha Abo" },
                { name: 'Cegrupo', data: 'Cegrupo', title: "Tipo" },
                { name: 'Ceconcepto', data: 'Ceconcepto', title: "Concepto" },
                { name: 'Exresp', data: 'Exresp', title: "Resp" },
                { name: 'Exobs', data: 'Exobs', title: "Observaciones" },
                { name: 'Uslogin', data: 'Uslogin', title: "Usuario" },
                { name: "ivr", data: "ivr", title: "", formatter: [this, "detallePreReporte"], orderable: false },
                { name: "elimina", data: "elimina", title: "", formatter: [this, "formatearCancelar"], orderable: false },

            ],
            displayInputs: {
                nrreporte: 0,
                svindice: 0,
                aiclave: 0,
                CI: true,
                uslogin: "",
            },
            formatterActions: [
                { click: [this, "cancelarServicio"] },
                { click: [this, "EditarMovimiento"] }
            ],
            isMovil: true,
            ci: true,
            datos: '',
            mostrarAlert: false,
            asistenciaurl: '',
        };
    },
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        }
    },
    methods: {
        CancelarShow() {
            this.showcargando = false;
        },
        async movimientossinCI() {
            this.showcargando = true;
            //let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
            this.displayInputs = {
                nrreporte: this.datos.nrreporte,
                svindice: this.datos.svindice,
                CI: this.switchci,
                aiclave: this.datos.aiclave,
                uslogin: MetodosGenerales.ObtenerUserName(),
            };

        },
        async Eliminar(item) {

            this.$swal({
                position: "center",
                icon: "warning",
                text: "¿Está seguro que desea eliminar el movimiento?",
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirmar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.showcargando = true;
                    let data = new FormData();
                    data.append("nrreporte", this.nrreporte);
                    data.append("svindice", this.svindice);
                    data.append("ceclave", item.ceclave);
                    data.append("exid", item.exid);
                    movimiento.EliminarMovimiento(this, data).then(data => {
                        if (data[0].respuesta == 1) {
                            this.listado = this.listado.filter((x) => x.exid !== item.exid);
                            this.$swal({
                                position: "center",
                                icon: "success",
                                text: "El movimiento se elimino correctamente",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: true,
                                timer: 2000,
                            });
                        }
                        else {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                text: "Ocurrio un error, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: true,
                                timer: 2000,
                            });
                        }
                        this.showcargando = false;
                    });


                }
            });
        },
        async Editar(item) {
            this.showcargando = true;
            let param = { exid: item.exid, obs: item.Exobs, nombre: this.$route.name }
            await MetodosGenerales.guardarEnSesionInfoReporte(param, 'param');
            this.$router.push({ path: this.asistenciaurl + '/EditarMovimiento' });
        },
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },
        mvisto(datos) {
            return datos.Visto == 1 ? `<span class="checkedEl"><i class="v-icon notranslate mdi mdi-check-all"></i></span>` : `<span><i class="v-icon notranslate mdi mdi-check-all"></i></span>`;
        },
        tpreporte(datos) {
            return datos.Esid == 7 ? `<i aria-hidden="true" class="v-icon notranslate mdi mdi-lock-open-variant theme--light success--text"></i>` : `<i aria-hidden="true" class="v-icon notranslate mdi mdi-lock-open theme--light error--text"></i>`;
        },
        formatearCancelar(datos) {
            return datos.elimina ? `<div><button type="button" class="eliminar v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default error dt-formatterAction" data-action="0" data-params="${datos.exid}" title="Eliminar"><span class="v-btn__content"><i data-v-6d45dbae="" aria-hidden="true" class="v-icon notranslate mdi mdi-trash-can-outline theme--light"></i></span></button></div>` : '';

        },
        detallePreReporte(datos) {
            return datos.ivr ? `<div><button type="button" class="editar v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default success dt-formatterAction" data-action="1" data-params="${datos.exid}" title="Editar"><span class="v-btn__content"><i data-v-6d45dbae="" aria-hidden="true" class="v-icon notranslate mdi mdi-file-document-edit-outline theme--light"></i></span></button></div>` : ``;
        },

        cancelarServicio(params, datos, fila) {
            this.$swal({
                title: "Eliminar",
                text: "¿Está seguro que desea eliminar el movimiento?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then((willDelete) => {
                if (willDelete.value) {
                    this.showcargando = true;
                    let data = new FormData();
                    data.append("nrreporte", this.nrreporte);
                    data.append("svindice", this.svindice);
                    data.append("ceclave", datos.ceclave);
                    data.append("exid", datos.exid);
                    movimiento.EliminarMovimiento(this, data).then(data => {
                        if (data[0].respuesta == 1) {
                            this.$swal({
                                position: "center",
                                icon: "success",
                                text: "El movimiento se eliminó correctamente",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                confirmButtonColor: "#3085d6",
                                confirmButtonText: "Aceptar",
                            }).then((will) => {
                                //this.$emit("reload");
                                //this.apiDT.ajax.reload();
                                window.location.reload();
                            })
                        }
                        else {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                text: "Ocurrio un error, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: true,
                                timer: 2000,
                            });
                        }
                    });
                }
            });
        },
        async EditarMovimiento(params, datos, fila) {
            this.showcargando = true;
            let param = { exid: datos.exid, obs: datos.Exobs, nombre: this.$route.name }
            await MetodosGenerales.guardarEnSesionInfoReporte(param, 'param');
            //this.$router.push({ name: `EditarMovimiento` });
            this.$router.push({ path: this.asistenciaurl + '/EditarMovimiento' });
        },

    },

    async mounted() {
        this.datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        this.nrreporte = this.datos.nrreporte;
        this.svindice = this.datos.svindice;
        this.aiclave = this.datos.aiclave;

        //let formData = new FormData();
        //formData.append("nrreporte", this.datos.nrreporte);
        //formData.append("svindice", this.datos.svindice);
        //await Asistencia.ObtenerUrl(formData).then(data => {
        //    console.log(data);
        //    if (data.success == true) {
        //        this.asistenciaurl = data.result;
        //    }
        //    else
        //        this.asistenciaurl = '';
        //});
        this.asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);

        if (this.datos.aiclave == 5) {
            this.ci = false;
            this.columns = [
                { name: 'Visto', data: 'Visto', title: "Visto", formatter: [this, "mvisto"], orderable: false },
                { name: 'Esid', data: 'Esid', title: "T.P.", formatter: [this, "tpreporte"], orderable: false },
                { name: 'hmfhsistema', data: 'hmfhsistema', title: "Fecha" },
                { name: 'hmfecha', data: 'hmfecha', title: "Fecha Abo" },
                { name: 'crinstancia', data: 'crinstancia', title: "Instancia" },
                { name: 'cretapa', data: 'cretapa', title: "Etapa" },
                { name: 'hmactualizacion', data: 'hmactualizacion', title: "Actualización" },
                { name: 'Usuario', data: 'Usuario', title: "Usuario" },
            ];
            this.urlListado = 'Movimientos/MovimientoRCM';
        }
        this.displayInputs = {
            nrreporte: this.datos.nrreporte,
            svindice: this.datos.svindice,
            aiclave: this.datos.aiclave,
            CI: true,
            uslogin: MetodosGenerales.ObtenerUserName(),

        };
        this.abrir = true;


        var deshabilitado = await General.VerificarReporte(this.datos);


        if (deshabilitado == 1) {
            this.mostrarAlert = true;
            this.showcargando = false;
        }


    }
}
</script>


<style scoped>
.title-card-style {
    padding: 1.5px !important;
    max-height: auto;
}

.card-title-text {
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-size: 1em;
    color: white;
}

.collapsable-container {
    background-color: white;
    height: auto !important;
}

.cellT {
    width: 11%;
}
.checkedEl {
    color: #34B7F1 !important;
}
</style>